module.exports = __webpack_public_path__ + "img/home.52c9e339.svg";